import { Component, inject, signal } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { HeaderAppComponent } from '../../headers/header-app/header-app.component';
import { FormTemplateComponent } from '../../../shared/screen-templates/form-template/form-template.component';
import { PayeeHorizontalLineComponent } from '../../../shared/payee-horizontal-line/payee-horizontal-line.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-get-password-link-success',
  templateUrl: './get-password-link-success.component.html',
  styleUrls: ['./get-password-link-success.component.scss'],
  imports: [
    HeaderAppComponent,
    FormTemplateComponent,
    PayeeHorizontalLineComponent,
    MatProgressSpinner,
  ],
})
export class GetPasswordLinkSuccessComponent {
  private authService = inject(AuthService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private snackbar = inject(MatSnackBar);

  readonly loading = signal(false);
  emailSent = false;

  readonly email: string;

  constructor() {
    this.email = this.route.snapshot.queryParams.email;

    if (!this.email) {
      this.router.navigateByUrl('/login');
    }
  }

  async resendForgotPasswordEmail() {
    if (this.loading() || this.emailSent) {
      return;
    }

    try {
      this.loading.set(true);
      this.emailSent = true;
      await this.authService.sendPasswordResetEmail({
        email: this.email,
      });
      this.snackbar.open('Email elküldve!', '', {
        duration: 15000,
      });
    } finally {
      this.loading.set(false);
      setTimeout(() => (this.emailSent = false), 15000);
    }
  }
}
